import { Environment } from './env';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'
import * as $ from 'jquery'
import { ThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { Session, UsersAPI } from './api';
import Login from './pages/Login/Login';
import Main from './main';
import bugsnag from '@bugsnag/js'
import bugsnagReact from '@bugsnag/plugin-react'
import './styles/all.scss';
import 'devextreme/dist/css/dx.common.css'
import { SkeletonTheme } from 'react-loading-skeleton';
import { Platform, PlatformContextProvider } from './components/context/platform';
import { sp } from './utils/platformSelect';
import { InitialFilterValues } from './components/context/filter';

let ErrorBoundary = class extends React.Component { public render() { return this.props.children } }
if (process.env.REACT_APP_STAGE != 'local') {
    const pack = require('../package.json');
    const bugsnagClient = bugsnag({ apiKey: 'ff3293ab180d3b616e6c4054dac97d9c', releaseStage: process.env.REACT_APP_ENV, appVersion: pack.version })
    bugsnagClient.use(bugsnagReact, React)
    ErrorBoundary = bugsnagClient.getPlugin('react')
}

Session.setAPIURL(Environment.API)
Session.setUserAgent('BPM Admin')

const supreme = createMuiTheme({
    palette: {
        primary: {
            main: '#f73e00',
            dark: '#000',
        }, text: {
            primary: 'rgba(0, 0, 0, 0.87)'
        }
    },
    typography: {
        fontFamily: [
            'gerstner_programm_fslmedium',
            'Poppins',
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
    }
});
const latino = createMuiTheme({
    palette: {
        primary: {
            main: '#3D6BED',
            dark: '#000',
        }, text: {
            primary: 'rgba(0, 0, 0, 0.87)'
        }
    },
    typography: {
        fontFamily: [
            'gerstner_programm_fslmedium',
            'Poppins',
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
    }
});
const create = createMuiTheme({
    palette: {
        primary: {
            main: '#1af085',
            dark: '#000',
        }, text: {
            primary: 'rgba(0, 0, 0, 0.87)'
        }
    },
    typography: {
        fontFamily: [
            'gerstner_programm_fslmedium',
            'Poppins',
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
    }
});
ReactDOM.render(
    <App />
    ,
    document.getElementById('root') as HTMLElement
);
function injectHistoryFunctions(ref: BrowserRouter | null) {
    if (ref) {
        const history = (ref as any).history as any
        const originalPush = history.push.bind(history)
        history.push = function (path: string, state?: any) {
            if (typeof path === 'object') {
                return originalPush(path)
            }
            if (!path.includes('?')) {
                path = path + history.location.search
            }
            return originalPush(path, state)
        }
    }
}
function App() {
    const [currentPlatform, setCurrentPlatform] = React.useState<Platform>(InitialFilterValues.platform)
    document.addEventListener('platform', (platform: CustomEvent) => {
        setCurrentPlatform(platform.detail)
        document.getElementById('root')?.classList.remove('platform-latino', 'platform-create', 'platform-supreme')
        document.getElementById('root')?.classList.add(`platform-${platform.detail}`)

        $('.hide-' + platform.detail).each((_, el) => {
            if ((el as any).href) {
                if ((el as any).href == (location.origin + location.pathname)) {
                    window.history.pushState('dashboard', 'Dashboard', '/dashboard')
                }
            }
        })
    })
    return <ErrorBoundary>
        <BrowserRouter ref={(ref) => {
            injectHistoryFunctions(ref)
        }}>
            <ThemeProvider theme={sp(currentPlatform, { create: create, supreme: supreme, latino: latino })}>
                <SkeletonTheme color="var(--platform)" highlightColor="#ffffffA0">
                    <PlatformContextProvider value={currentPlatform}>
                        <Switch>
                            <Route path='/login' render={(props) => <Login {...props} />} />
                            <Route path='/logout' render={() => {
                                UsersAPI.logout()
                                return (
                                    <Redirect to="/login" />
                                )
                            }} />
                            <Route path='/' component={Main} />
                        </Switch>
                    </PlatformContextProvider>
                </SkeletonTheme>
                <svg>
                    <linearGradient id="svg-platform">
                        <stop stopColor="var(--platform)" />
                    </linearGradient>
                </svg>
            </ThemeProvider>
        </BrowserRouter>
    </ErrorBoundary>
}
declare global {
    interface Array<T> {
        unique(property?: string): Array<T>;
        chunk(size: number): Array<Array<T>>
        equals(array: Array<any>): boolean
    }
    interface JQuery {
        draggable: (opts) => JQuery
        droppable: (opts) => JQuery
    }
    interface String {
        toCamelCase: () => string
    }
}
$.ajaxSetup({
    xhrFields: {
        withCredentials: true
    }
})
let open = XMLHttpRequest.prototype.open;
XMLHttpRequest.prototype.open = function () {
    this.withCredentials = true;
    const url = arguments[1]
    if (url.includes('bugsnag')) {
        this.withCredentials = false;
    }
    open.apply(this, arguments);
}
Array.prototype.unique = function <T>(this: Array<T>, property?: string) {
    let s = new Set();
    return this.filter((value, index, self) => {
        if (property && s.has(value[property])) {
            return false;
        } else if (property) {
            s.add(value[property])
            return true;
        }
        if (s.has(value)) {
            return false;
        }
        s.add(value);
        return true;
    })
}

Array.prototype.chunk = function <T>(this: Array<T>, chunkSize: number) {
    var R = new Array<Array<T>>()
    for (var i = 0; i < this.length; i += chunkSize)
        R.push(this.slice(i, i + chunkSize));
    return R;
}
Array.prototype.equals = function <T>(this: Array<T>, b: Array<any>) {
    return Array.isArray(this) &&
        Array.isArray(b) &&
        this.length === b.length &&
        this.every((val, index) => val === b[index]);
}
String.prototype.toCamelCase = function (this: String) {
    return this
        .replace(/\s(.)/g, function ($1) { return $1.toUpperCase(); })
        .replace(/\s/g, '')
        .replace(/^(.)/, function ($1) { return $1.toLowerCase(); });
}


// WEBPACK FOOTER //
// ./src/index.tsx